/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useMemo} from 'react'
import {Outlet} from 'react-router-dom'
import {getAuthBackgroundUrl} from '../../constructor/helpers/dynamicStyles'

const DEFAULT_BG_PATH = '/media/crm/assets/bg-body.jpeg'

const AuthLayout = () => {
    useEffect(() => {
        const root = document.getElementById('root')
        if (root) {
            root.style.height = '100%'
        }
        return () => {
            if (root) {
                root.style.height = 'auto'
            }
        }
    }, [])

    const backgroundUrl = useMemo(() => {
        const bg = getAuthBackgroundUrl()
        if (bg && bg.trim() !== '') {
            return bg
        }
        return `${window.location.origin}${DEFAULT_BG_PATH}`
    }, [])

    return (
        <div
            className='auth-layout d-flex flex-column flex-lg-row flex-column-fluid h-100'
            style={{backgroundImage: `url(${backgroundUrl}`}}
        >
            {/* begin::Body */}
            <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
                {/* begin::Form */}
                <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
                    {/* begin::Wrapper */}
                    <div className='auth_formContainer w-lg-500px p-12'>
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    )
}

export {AuthLayout}
